
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { ISchedulerConfig } from '@samc/querybuilder';
  import { SchedulerInput } from './SchedulerInput.react.jsx';

  @Component({
    name: 'scheduler-input-component',
    components: { SchedulerInput: (SchedulerInput as any) }
  })
  export default class SchedulerInputComponent extends Vue {
    @Prop() public defaultValue?: ISchedulerConfig;
    @Prop() public timeZone?: string;
    @Prop() public onChange?: (e: ISchedulerConfig) => void;
  }
